import React from "react";
import { useSelector } from "react-redux";
import "./givingback.css";
import "../../index.css";
import { Col, Container, Row } from "react-bootstrap";
import { AutoVideo } from "../../Components/AutoVideo";
import { htmlString } from "../../services/helper";

const GivingBack = () => {
  const givingBackContent = useSelector(
    (state) => state.appsetting.giving_back_content
  );
  const title = givingBackContent.name;
  const headerVideo = givingBackContent.header_videoISfile;
  const mainSubHeading = givingBackContent.main_subheading;
  const mainText = htmlString(givingBackContent.main_textISsmallplaintextbox);
  const secondSubHeading = givingBackContent.secondary_subheading;
  const secondText = htmlString(givingBackContent.secondary_textISsmallplaintextbox);
  const image1 = givingBackContent.image01ISfile;
  const image2 = givingBackContent.image02ISfile;
  const image3 = givingBackContent.image03ISfile;

  const reveal = () => {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  };
  reveal();
  window.addEventListener("scroll", reveal);
  return (
    <div>
      <div className="video-term reveal fade-in active">
        <AutoVideo className="headervideo" src={headerVideo}/>
      </div>
      <div className="position-relative">
        <Container className='pt-5'>
          <div className="header-wrapper">
            <h1 className="header-text">{title}</h1>
          </div>
          <Row className="justify-content-md-center mt-5">
            <Col lg="8">
              <div className="first-row">
                <div className="maindiv-image">
                  {image2 && (
                    <div className="image-div mb-4">
                      <img src={image2} alt="image2" />
                    </div>
                  )}
                  {image1 && (
                    <div className="image-div mb-4">
                      <img src={image1} alt="image1" />
                    </div>
                  )}
                </div>
                <div className="image-text">
                  <h2>{mainSubHeading}</h2>
                  <div
                    dangerouslySetInnerHTML={{__html: mainText}}
                  />
                </div>
              </div>
            </Col>
            <Col lg="4">
              <div className="">
                <div className="">
                  {image3 && (
                    <div className="side-blog">
                      <img src={image3} alt="image3" />
                    </div>
                  )}
                </div>
                <div className="side-text">
                  <h2>{secondSubHeading}</h2>
                  <div
                    dangerouslySetInnerHTML={{__html: secondText}}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default GivingBack;
